<template>
  <div>
    <el-upload
      action="/api/common/qiniu/upload"
      :limit="limit"
      list-type="picture-card"
      class="imgWrap"
      ref="upload"
      multiple
      :headers="{ token: token }"
      :on-preview="handlePictureCardPreview"
      :before-upload="beforeAvatarUpload"
      :on-remove="handleRemoveImg"
      :file-list="fileListImg"
      :on-exceed="handleExceed"
      accept="image/jpeg, image/png, image/gif"
      :auto-upload="true"
      :http-request="httpRequestBackImg"
    >
      <i class="el-icon-plus"></i>
    </el-upload>
    <el-dialog
      :visible.sync="dialogVisibleUrl"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <template #title>
        <div class=""></div>
      </template>
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { getStorage } from "@/storage";
export default {
  name: "Uploadimg",
  props: {
    limit: {
      type: Number,
      default: 9,
    },
    fileListImg: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      dialogImageUrl: "",
      dialogVisibleUrl: false,
      files: [],
    };
  },
  methods: {
    // 图片上传之前
    beforeAvatarUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error("上传文件大小不能超过 50MB!");
      }
      return isLt50M;
    },
    // 图片自定义上传方法
    httpRequestBackImg(file) {
      this.$emit("update:loading", true);
      var formData = new FormData();
      formData.append("file[]", file.file);
      this.$http
        .post("/common/qiniu/uploadFilePatch", { formData, type: "upload" })
        .then((res) => {
          if (res.code == 1) {
            let str = {
              name: res.data[0].name,
              url: res.data[0].all_path_url,
            };
            // this.files.push(str);
            this.$emit("imgChange", [...this.fileListImg, str]);
          }
        })
        .finally(() => {
          this.$emit("update:loading", false);
        });
    },
    handleRemoveImg(file, fileList) {
      fileList.map((v,i) => {
        if(file.uid === v.uid) {
          fileList.splice(i, 1);
        }
      })
      this.$emit("imgChange", fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleUrl = true;
    },
    handleExceed(files, fileList) {
      this.$message.warning(`限制选择 ${this.limit} 个`);
      return;
    },
  },
};
</script>

<style lang="scss" scoped>
.imgWrap ::v-deep .el-upload--picture-card {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
.imgWrap ::v-deep .el-upload-list__item {
  width: 80px !important;
  height: 80px !important;
}
.imgWrap ::v-deep .avatar-uploader-icon {
  width: 80px !important;
  height: 80px !important;
  line-height: 80px !important;
}
</style>